"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Profile = function Profile() {
  return _react2.default.createElement(
    "g",
    { id: "profile" },
    _react2.default.createElement("path", {
      d: "M242.740125,259.480249 C173.848056,259.480249 118,203.632193 118,134.740125 C118,65.8480562 173.848056,10 242.740125,10 C311.632193,10 367.480249,65.8480562 367.480249,134.740125 C367.480249,203.632193 311.632193,259.480249 242.740125,259.480249 Z M482.429775,387.904366 C491.791084,395.67439 497.756965,406.785845 499.061792,418.881497 L499.061792,488.735967 L0.101292671,488.735967 L0.101292671,418.881497 C-0.693490244,407.51045 3.21478858,396.311728 10.9121035,387.904366 C47.5025401,352.769231 137.10753,322 244.591937,322 C352.076345,322 445.631438,352.769231 482.429775,387.904366 Z",
      id: "Combined-Shape"
    })
  );
};

exports.default = Profile;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Profile.js
// module id = 2977
// module chunks = 4